import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Select } from 'components';
import { OptionType } from 'components/Select';
import { IConsumptionPoint, CONSUMPTION_POINT_FILTER_ALL } from 'services/consumptionPointService';

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.unit}px;
    min-width: 0;
    color: ${({ theme }) => theme.palette.common.white};
`;

const IconWrapper = styled.span`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

const LocationIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

interface IProps {
    className?: string;
    consumptionPoints: IConsumptionPoint[];
    selectedId: string;
    onChange: (id: string) => void;
}

const ConsumptionPointFilter = ({ className, consumptionPoints, selectedId, onChange }: IProps) => {
    const { t } = useTranslation();

    const options: OptionType[] = [
        { value: CONSUMPTION_POINT_FILTER_ALL, label: t('page:home.consumptionPointFilter.all') as string },
        ...consumptionPoints.map((consumptionPoint) => ({ value: consumptionPoint.id, label: consumptionPoint.name })),
    ];
    const selectedOption = options.find((option) => option.value === selectedId) ?? options[0];

    return (
        <Row className={className}>
            <IconWrapper>
                <LocationIcon />
            </IconWrapper>
            <Select
                options={options}
                selectedOption={selectedOption}
                handleChange={(option: any) => onChange(option.value)}
                isSearchable={false}
                menuPlacement="auto"
                menuPortal
                hideDropdownIndicator
                style={{
                    autoWidth: true,
                    minWidth: 140,
                    menuWidth: 260,
                    height: 34,
                    fontSize: 14,
                    hideInput: true,
                    valueMargin: 'auto 0',
                    valueContainer: {
                        // A tiny container font-size centers the value vertically and avoids the
                        // vertical scrollbar; the visible text keeps its own size on the span.
                        fontSize: 2,
                        justifyContent: 'center',
                    },
                }}
            />
        </Row>
    );
};

export default ConsumptionPointFilter;
